import { render } from "./VoiceCommandModal.vue?vue&type=template&id=2ec0ff8c&scoped=true"
import script from "./VoiceCommandModal.vue?vue&type=script&lang=js"
export * from "./VoiceCommandModal.vue?vue&type=script&lang=js"

import "./VoiceCommandModal.vue?vue&type=style&index=0&id=2ec0ff8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec0ff8c"]])

export default __exports__